import { isObject, type SiteMaterialList, useApiTradeV1TradeCompaniesSiteMaterialsRetrieve } from 'api';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

type Props = Omit<AutocompleteFieldProps<SiteMaterialList>, 'options'> & {
  tradeCompanyId?: number;
  tradeSite?: number;
};

export const SiteMaterialAutocomplete = ({ tradeCompanyId, tradeSite, required = false, ...rest }: Props) => {
  const { data, isLoading } = useApiTradeV1TradeCompaniesSiteMaterialsRetrieve(
    tradeCompanyId ?? 0,
    {
      site: tradeSite,
    },
    {
      query: {
        enabled: Boolean(tradeCompanyId),
      },
    }
  );

  return (
    <AutocompleteField<SiteMaterialList>
      data-testid="site-material-selector"
      options={data?.results || []}
      loading={isLoading}
      disabled={!tradeCompanyId}
      getOptionLabel={(option) => {
        if (isObject(option)) {
          return `${option.material_spec.title} ${option.grade.name} ${option.site.full_address}`;
        }
        return '';
      }}
      valueField="id"
      required={required}
      {...rest}
    />
  );
};
